module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isIcon) ? _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'primary'
    },
    on: {
      "click": _vm.showPaymentModal
    }
  }, [_vm._v("\n        Payment Details\n    ")]) : _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1 btn-action",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "title": "Payment Summary"
    },
    on: {
      "click": _vm.showPaymentModal
    }
  }, [_c('i', {
    class: _vm.iconClass || 'fa fa-money'
  })]), _vm._v(" "), _c('b-modal', {
    ref: "paymentsModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Payment Details-#' + _vm.JobAssNo
    }
  }, [(_vm.getJobData) ? _c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Exp Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ExpClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Imp Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ImpClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Sline Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.SlineName))])], 1) : _vm._e(), _vm._v(" "), (_vm.getJobData) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Job Details",
      "active": _vm.activeTab === 'jobDetails'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Enq No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.EnqNo))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Enq Date : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.EnqDate))]), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Subscription\n                                                    ID :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.id))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Subscription\n                                                    Status\n                                                    : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.subscription_status_detials_status ==
    "1" ? "Subscribed" : "Failed"))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking\n                                                    Type :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.bookingType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Contract\n                                                    No :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.contract_no))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking\n                                                    For :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.booking_for))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking\n                                                    No :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.booking_no))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("BRF\n                                                    No :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.enquiry_booking_no))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.getSubscription && (_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Enq\n                                                    Price No :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.getSubscription.enquiry_no))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Job Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.JobType))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Transport Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.JobTransportType))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Job No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.JobNo))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Job Date : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.JobDate))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Exp Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ExpClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Imp Client Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ImpClientName))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Sline Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.SlineName))]), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("SOB :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.SOB))]) : _vm._e(), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Vessel\n                                                    Voyage : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.VesselVoyage))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("ETA Estimated : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ETAEstimated))]), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("ETA\n                                                    Actual : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.ETAActual))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("MBL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.MBL))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("MBL Date : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.MBLDate))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("MBL Release Date : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.MBLReleaseDate))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("HBL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.HBL))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POR : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.POR))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.POL))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POD : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.POD))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FPOD : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.FPOD))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PICK : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.PICK))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("HAND : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.HAND))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("STUFF : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.STUFF))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Raised From : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.RaisedFrom))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Raised By : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.RaisedBy))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Total Income : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.totPLIncomes))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Total Expense : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.totPLExpenses))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Total Profit/Loss : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.totPLProfit))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("P/L Status : ")]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": _vm.getJobData.getJob._rowVariant ? _vm.getJobData.getJob._rowVariant : (_vm.getJobData.getJob.totPLLabel === 'Loss' ? 'danger' : _vm.getJobData.getJob.totPLLabel === 'Profit' ? 'success' : 'secondary')
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.getJobData.getJob.totPLLabel || "Normal") + "\n                                                ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Container Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.JobTContainerType))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Containers : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.Containers))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Checking By : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.LoginUserName))]), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Risk :\n                                                ")]), _vm._v(_vm._s(_vm.getJobData.getJob.sub_noti_risk))]) : _vm._e(), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Risk\n                                                    Desc : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.sub_noti_risk_description))]) : _vm._e(), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Risk\n                                                    Conclusion : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.sub_noti_conclusion))]) : _vm._e(), _vm._v(" "), ((_vm.getJobData.getJob.JobType.indexOf('FF') >= 0)) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Risk\n                                                    Event MSG : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.sub_noti_event_message))]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "BRF Details",
      "active": _vm.activeTab === 'brfDetails'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.getJobData.getJob.BrfData) ? _c('b-card', [_c('b-card-text', [_c('b-row', [(_vm.getJobData.getJob.BrfData.BrfNo) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("BRF No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BrfNo))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BrfEnqNo) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Brf Enq No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BrfEnqNo))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BookingNo) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BookingNo))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BookingType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BookingType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BookingFor) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking For : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BookingFor))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.RecordType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Record Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.RecordType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.SpotNonSpot) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Spot/NonSpot : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.SpotNonSpot))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.TransportType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Transport Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.TransportType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ShipmentType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Shipment Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ShipmentType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.DeliveryMode) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Delivery Mode : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.DeliveryMode))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.IncoTerm) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Inco Term : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.IncoTerm))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.FirstMileBooking) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("First Mile Booking : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.FirstMileBooking))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.POR) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POR : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.POR))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.POL) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.POL))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.POD) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POD : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.POD))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.FPOD) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FPOD : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.FPOD))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.EmptyPick) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Empty Pick : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.EmptyPick))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.RaisedFrom) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Raised From : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.RaisedFrom))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ContainerType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Container Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ContainerType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.CommodityType) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity Type : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.CommodityType))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.CommodityName) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity Name : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.CommodityName))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.OtherCommodity) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Other Commodity : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.OtherCommodity))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.CargoWeight) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Cargo Weight : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.CargoWeight))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.PackingCode) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Packing Code : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.PackingCode))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ImdgClass) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Imdg Class : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ImdgClass))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.UNNumber) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("UN Number : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.UNNumber))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.TemperatureRequired) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Temperature : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.TemperatureRequired))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.Humidity) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Humidity : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.Humidity))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ETD) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("ETD : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ETD))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ValidTill) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Valid Till : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ValidTill))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ValidForSail) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Valid For Sail : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ValidForSail))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.SiCutOfDate) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("SI Cut Off : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.SiCutOfDate))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.HandoverDate) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Handover Date : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.HandoverDate))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.QuotationTill) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Quotation Till : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.QuotationTill))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.TemplateValidTill) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Template Valid Till : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.TemplateValidTill))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.CurrencyName) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Currency : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.CurrencyName))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.currencyCode) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Currency Code : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.currencyCode))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.FreightTermsMbl) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Freight Terms MBL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.FreightTermsMbl))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.FreightTermsHbl) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Freight Terms HBL : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.FreightTermsHbl))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.DestinationCharges) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Dest. Charges : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.DestinationCharges))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ContractNo) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Contract No : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ContractNo))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.ClientName) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Client : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.ClientName))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.SalesPerson) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Sales Person : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.SalesPerson))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BookingRaisedBy) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Raised By : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BookingRaisedBy))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.AgentHandlingExpense) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Agent Handling Exp : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.AgentHandlingExpense))]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('hr')]), _vm._v(" "), (_vm.getJobData.getJob.BrfData.Remarks) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Remarks : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.Remarks))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.BLInstruction) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("BL Instruction : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.BLInstruction))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.PDA) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PDA : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.PDA))]) : _vm._e(), _vm._v(" "), (_vm.getJobData.getJob.BrfData.FreeDays) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Free Days : ")]), _vm._v(_vm._s(_vm.getJobData.getJob.BrfData.FreeDays))]) : _vm._e()], 1), _vm._v(" "), (_vm.getJobData.getJob.BrfData.PricingList && _vm.getJobData.getJob.BrfData.PricingList.length > 0) ? _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h6', [_vm._v("Pricing List")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.BrfData.PricingList,
      "fields": _vm.pricingFields,
      "small": ""
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Note",
      "active": _vm.activeTab === 'credit_note'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.CRDRList,
      "fields": _vm.crdrFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))]), _vm._v(" "), (row0.item.fullDocumentLink != '') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.viewDoc(row0.item.fullDocumentLink)
            }
          }
        }, [_vm._v("View")]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Expense",
      "active": _vm.activeTab === 'expense'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.ExpenseList,
      "fields": _vm.expenseFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))]), _vm._v(" "), (row0.item.fullDocumentLink != '') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.viewDoc(row0.item.fullDocumentLink)
            }
          }
        }, [_vm._v("View")]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Additional Task",
      "active": _vm.activeTab === 'additionalTask'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.AdditionalTaskList,
      "fields": _vm.additionalTaskFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Sline",
      "active": _vm.activeTab === 'sline'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.SlineList,
      "fields": _vm.SlineFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "slineBlNo",
      fn: function(row1) {
        return [_c('span', [_vm._v("Bl No : " + _vm._s(row1.item.slineBlNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Due Date : " + _vm._s(row1.item.dueDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("SOB : " + _vm._s(row1.item.sobDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("SC Category : " + _vm._s(row1.item.scCategory))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("SC Remark : " + _vm._s(row1.item.scremark))]), _c('br')]
      }
    }, {
      key: "invoiceType",
      fn: function(row1) {
        return [_c('span', [_vm._v("Inv Type : " + _vm._s(row1.item.invoiceType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv No : " + _vm._s(row1.item.invoiceNumber))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Category : " + _vm._s(row1.item.invoiceCategory))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("AMT : " + _vm._s(row1.item.amount))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Currency : " + _vm._s(row1.item.currency))]), _c('br')]
      }
    }, {
      key: "currency",
      fn: function(row1) {
        return [_c('span', [_vm._v("Pay Mode : " + _vm._s(row1.item.paymode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Paid AMT : " + _vm._s(row1.item.paidAmount))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pay Date : " + _vm._s(row1.item.payDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pay Reference : " + _vm._s(row1.item.payReference))]), _c('br')]
      }
    }, {
      key: "createdBy",
      fn: function(row1) {
        return [_c('span', [_vm._v("Created By : " + _vm._s(row1.item.createdBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Created At : " + _vm._s(row1.item.loginTime))]), _c('br')]
      }
    }, {
      key: "paymode",
      fn: function(row1) {
        return [(row1.item.blDraftUpload != '') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.viewDoc(row1.item.blDraftUpload)
            }
          }
        }, [_vm._v("View")]) : _vm._e()]
      }
    }, {
      key: "paidAmount",
      fn: function(row1) {
        return [(row1.item.slineInvoice != '') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.viewDoc(row1.item.slineInvoice)
            }
          }
        }, [_vm._v("View")]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Manifestation",
      "active": _vm.activeTab === 'manifestation'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.ManifestationList,
      "fields": _vm.ManifestFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Containers",
      "active": _vm.activeTab === 'containers'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.ContainerList,
      "fields": _vm.ContainerFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "GRN List",
      "active": _vm.activeTab === 'grn'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.GRNList,
      "fields": _vm.GRNFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))]), _vm._v(" "), (row0.item.fullDocumentLink != '') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.viewDoc(row0.item.fullDocumentLink)
            }
          }
        }, [_vm._v("View")]) : _vm._e()]
      }
    }, {
      key: "tptType",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.tptType == 1 ? 'Pridel' : row1.item.tptType == 2 ? 'Outsourced' : 'N/A'))]), _c('br')]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Tally Billing",
      "active": _vm.activeTab === 'tallybill'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.TallyList,
      "fields": _vm.TallyFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Reverse Tally Billing",
      "active": _vm.activeTab === 'revTallybill'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.reverse_tally_billing,
      "fields": _vm.ReverseTallyFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "custom-tab",
    attrs: {
      "title": "Reverse Expense",
      "active": _vm.activeTab === 'reverseExp'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getJobData.getJob.tally_billing_expense,
      "fields": _vm.ReverseExpenseFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closePaymentModal
    }
  }, [_vm._v("Close")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a681b0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/jobWisePaymentsDetails.vue
// module id = 2713
// module chunks = 0